import {ofType} from 'redux-observable';
import {concat, EMPTY, iif, of} from 'rxjs';
import {ajax} from 'rxjs/ajax';
import {catchError, filter, mergeMap, timeout, debounceTime, delay} from 'rxjs/operators';
import {AnyAction} from 'redux';
import * as WizardMXActions from '../../../actions/WizardMXActions';
import * as WizardActions from '../../../actions/WizardActions';
import * as CalculatorActions from '../../../actions/CalculatorActions';
import * as UIActions from '../../../actions/UIActions';
import * as LoanApplicationActions from '../../../actions/LoanApplicationActions';
import * as RoutesConstant from '../../../constants/RoutesConstant';
import {push} from 'connected-react-router';
import * as MC from '../../../constants/MotorcreditConstants';
import * as ErrorConstants from '../../../constants/ErrorConstants';
import {COUNTRIES} from '../../../constants/AppConstants';
import * as ValidateConstant from '../../../constants/ValidateConstant';
import * as WizardValidationUtils from '../../../utils/WizardValidationUtils';

import {
    mapStateToStepApplicantData,
    mapStateToStepApplicantDomicile,
    mapStateToStepApplicantEmployment,
    mapStateToStepApplicantEmploymentPartials,
    mapStateToStepOtherReferences,
    mapStateToStepInsurance,
    mapStateToStepCreditHistory,
    mapStateToStepValidateIdentityNIP,
    mapStateToStepValidateBureauNIP,
    mapStateToStepMarketingSource,
    mapStateToStepTurboCash,
    mapStateToHubspotData,
    mapStateToProfileSimulator
} from '../../../utils/WizardMXBodyMapper';
import {processApiError} from '../../../utils/ApiUtil';
import {addCredentialAndExecute, addHeadersServerless} from '../../../utils/RetryUtil';
import {isEmpty} from '../../../../common/utils/ValidationUtils';
import * as ModalActions from '../../../actions/ModalActions';
import {MODAL_TYPE} from '../../../constants/ModalConstants';
import * as WizardResponseValidationUtils from '../../../utils/WizardResponseValidationUtils';
import {LoanApplicationApplicantSummaryDTO} from '../../../types/mx/creditoReal/epics';
import {State} from '../../../types/mx/reducers';
import * as LoginActions from '../../../actions/LoginActions';
import * as CookieUtils from '../../../../common/utils/CookieUtils';
import * as StateConstants from '../../../constants/StateConstants';
import {mapCRLoanApplicationToDTO} from '../../../../common/utils/LoanUtils';
import {BankTarget} from '../../../types/mx/types';
import * as GlobalActions from '../../../../admin/actions/GlobalActions';
import {GLOBAL} from '../../../../pay-warranty/constants/LabelConstants';

export const goToHomeEpic = action$ =>
    action$.pipe(
        ofType(WizardMXActions.GO_TO_HOME_ACTION.name),
        mergeMap(action => of(push(RoutesConstant.CALCULATOR_PATH))));

export const goToTurboCashEpic = (action$, state$) =>
    action$.pipe(
        ofType(WizardMXActions.GO_TO_TURBO_CASH_ACTION.name),
        mergeMap(action => of(push(`${RoutesConstant.TURBO_CASH}/${state$.value.turboCash.loanApplication.token}`))));

export const goToSimulatorProfileEpic = (action$, state$) =>
    action$.pipe(
        ofType(WizardMXActions.GO_TO_SIMULATOR_PROFILE_ACTION.name),
        mergeMap(action => of(push(`${RoutesConstant.PROFILE_CALCULATOR}/${state$.value.creditoReal.loanApplication.token}`))));

export const goToApplicantDataMXAction = (action$, state$) =>
    action$.pipe(
        ofType(WizardMXActions.GO_TO_APPLICANT_DATA_MX_ACTION.name),
        mergeMap((action) => {
            const state = state$.value;
            return of(push(`${RoutesConstant.PERSONAL_DATA_PATH}/${state.creditoReal.loanApplication.token}`));
        })
    );

export const goToCalculatorMXAction = (action$, state$) =>
    action$.pipe(
        ofType(WizardMXActions.GO_TO_CALCULATOR_MX_ACTION.name),
        mergeMap((action) => {
            const state = state$.value;
            return of(push(`${RoutesConstant.CALCULATOR_PATH}/${state.creditoReal.loanApplication.token}`));
        })
    );

export const verifyCalculatorDataMXAction = (action$, state$) =>
    action$.pipe(
        ofType(WizardMXActions.VERIFY_CALCULATOR_DATA.name),
        mergeMap((action) => {
            const state = state$.value;
            let version = state.catalogs.versionSelected;
            if (!version || isEmpty(version.id)) {
                version = CookieUtils.getCookie(StateConstants.VERSION_SELECTED);
            }
            return iif(
                () => !version || isEmpty(version),
                of(push(`${RoutesConstant.CALCULATOR_PATH}`)),
                EMPTY
            );
        })
    );

export const saveApplicantDataMXAction = (action$, state$) =>
    action$.pipe(
        ofType(WizardMXActions.SAVE_APPLICANT_DATA_MX_ACTION.name),
        mergeMap((action: AnyAction) => {
            const state = state$.value;
            const token = state.creditoReal.loanApplication.token ? `/${state.creditoReal.loanApplication.token}` : '';
            const url = `${MC.MCC_URL(COUNTRIES.MX.id)}/loan-applications-dealer${token}`;
            const body = mapStateToStepApplicantData(state);
            const sendHubspot = state.creditoReal.loanApplication.receiveNewsPromotions;

            return concat(
                of(UIActions.IS_LOADING_ACTION.action(WizardMXActions.SAVE_APPLICANT_DATA_MX_ACTION.name)),
                addCredentialAndExecute(headers =>
                    token ? ajax.put(url, body, headers) : ajax.post(url, body, headers), state$.value).pipe(
                    timeout(MC.TIMEOUT),
                    mergeMap(({response, refreshTokenObs}: any) => {
                        console.log('------------------WizardMXActions.RETURNED_FROM_API----------------- ', response);
                        CookieUtils.cleanCookies(StateConstants.CALCULATOR_COOKIES);
                        return concat(
                            of(refreshTokenObs),
                            of(LoanApplicationActions.SET_HIGHEST_STEP_ACTION.action(body.extraData.step)),
                            of(WizardMXActions.SET_CREDIT_BUREAU_VALIDATION_MX_ACTION
                                .action(response.response.data.bureauNipValidated)),
                            iif(
                                () => sendHubspot,
                                of(WizardMXActions.SEND_HUBSPOT_DATA_ACTION.action()),
                                EMPTY
                            ),
                            iif(
                                () => isEmpty(token),
                                of(WizardActions.SET_LOAN_APPLICATION_TOKEN_ACTION
                                    .action(response.response.data.token)),
                                EMPTY
                            ),
                            of(WizardMXActions.SET_BUREAU_FAILED_ACTION.action(false)),
                            of(WizardMXActions.GO_TO_APPLICANT_DOMICILE_MX_ACTION.action()),
                            of(WizardMXActions.CLEAN_NIP_MX_ACTION.action()),
                            of(UIActions.IS_LOADED_ACTION
                                .action(WizardMXActions.SAVE_APPLICANT_DATA_MX_ACTION.name))
                        );
                    }),
                    catchError((error) => {
                        console.log('---------- EROROROROROOROR ::: ', error);
                        const errorIsApplicantHasAnotherApplication = Array.isArray(error) ?
                            error.includes(ErrorConstants.APPLICANT_HAS_ANOTHER_APPLICATION_ERROR) : false;

                        return processApiError([
                            UIActions.IS_LOADED_ACTION.action(WizardMXActions.SAVE_APPLICANT_DATA_MX_ACTION.name),
                            errorIsApplicantHasAnotherApplication ?
                                WizardMXActions.APPLICANT_HAS_ANOTHER_APPLICATION_MX_ACTION.action() :
                                UIActions.ERROR_GENERAL_ACTION.action(error, action, url, body, token ? 'PUT' : 'POST')
                        ])(error);
                    })
                )
            );
        })
    );

export const sendHubspotDataAction = (action$, state$) =>
    action$.pipe(
        ofType(WizardMXActions.SEND_HUBSPOT_DATA_ACTION.name),
        mergeMap((action: AnyAction) => {
            const state = state$.value;
            const url = `${MC.SERVERLESS_ENDPOINT}/hubspot/post`;
            const body = mapStateToHubspotData(state);

            return concat(
                of(UIActions.IS_LOADING_ACTION.action(WizardMXActions.SEND_HUBSPOT_DATA_ACTION.name)),
                addHeadersServerless(headers =>
                    ajax.post(url, body, headers)).pipe(
                    timeout(MC.TIMEOUT),
                    mergeMap(({response}) => {
                        console.log('------------------WizardMXActions.RETURNED_FROM_API----------------- ', response);
                        return concat(
                            of(UIActions.IS_LOADED_ACTION
                                .action(WizardMXActions.SEND_HUBSPOT_DATA_ACTION.name))
                        );
                    }),
                    catchError((error) => {
                        return processApiError([
                            UIActions.IS_LOADED_ACTION.action(WizardMXActions.SEND_HUBSPOT_DATA_ACTION.name),
                            UIActions.ERROR_GENERAL_ACTION.action(error, action, url, body, 'POST')
                        ])(error);
                    })
                )
            );
        })
    );

export const saveCalculatorDataMXAction = (action$, state$) =>
    action$.pipe(
        ofType(WizardMXActions.SAVE_CALCULATOR_DATA_MX_ACTION.name),
        mergeMap((action: AnyAction) => {
            const state = state$.value;
            const token = state.creditoReal.loanApplication.token ? `/${state.creditoReal.loanApplication.token}` : '';
            const url = `${MC.MCC_URL(COUNTRIES.MX.id)}/loan-applications-dealer${token}`;
            const body = mapStateToStepApplicantData(state);
            return concat(
                of(UIActions.IS_LOADING_ACTION.action(WizardMXActions.SAVE_CALCULATOR_DATA_MX_ACTION.name)),
                addCredentialAndExecute(headers => ajax.put(url, body, headers), state$.value).pipe(
                    timeout(MC.TIMEOUT),
                    mergeMap(({response, refreshTokenObs}: any) => {
                        console.log('------------------WizardMXActions.RETURNED_FROM_API-------------------- ',
                            response);
                        return concat(
                            of(refreshTokenObs),
                            of(LoanApplicationActions.SET_HIGHEST_STEP_ACTION.action(body.extraData.step)),
                            of(WizardMXActions.GO_TO_APPLICANT_DATA_MX_ACTION.action()),
                            of(UIActions.IS_LOADED_ACTION
                                .action(WizardMXActions.SAVE_CALCULATOR_DATA_MX_ACTION.name))
                        );
                    }),
                    catchError((error) => {
                        console.log('---------- EROROROROROOROR ::: ', error);
                        const errorIsApplicantHasAnotherApplication = Array.isArray(error) ?
                            error.includes(ErrorConstants.APPLICANT_HAS_ANOTHER_APPLICATION_ERROR) : false;

                        return processApiError([
                            UIActions.IS_LOADED_ACTION.action(WizardMXActions.SAVE_CALCULATOR_DATA_MX_ACTION.name),
                            errorIsApplicantHasAnotherApplication ?
                                WizardMXActions.GOT_API_ERROR_ACTION
                                    .action(ErrorConstants.APPLICANT_HAS_ANOTHER_APPLICATION_ERROR) :
                                UIActions.ERROR_GENERAL_ACTION.action(error, action, url, body, 'PUT')
                        ])(error);
                    })
                )
            );
        })
    );

export const getLocationByPostalCodeHome = (action$, state$) =>
    action$.pipe(
        ofType(WizardActions.CHANGE_HOME_POSTAL_CODE_ACTION.name),
        debounceTime(300),
        mergeMap((action: AnyAction) => {

            const defaultCatalog = WizardValidationUtils.defaultCatalog;
            const COUNT_AUTO_SELECTED = 1;

            if (action.error === null) {
                const url = `${MC.MCC_URL(action.country)}/catalogs/locations/${action.postalCode}`;
                return concat(
                    of(UIActions.IS_LOADING_ACTION.action(
                        WizardActions.CHANGE_HOME_POSTAL_CODE_ACTION.name)
                    ),
                    addCredentialAndExecute(headers => ajax.get(url, headers), state$.value).pipe(
                        timeout(MC.TIMEOUT),
                        mergeMap(({response, refreshTokenObs}: any) => {
                            const dataResponse = response.response.data;

                            const calcColonyError = dataResponse.colony.length > COUNT_AUTO_SELECTED ?
                                ValidateConstant.ERROR_REQUIRED : null;

                            return concat(
                                of(refreshTokenObs),
                                of(WizardActions.GOT_LOCATIONS_APPLICANT_HOME_MX_ACTION
                                    .action(dataResponse)),
                                of(WizardActions.CHANGE_HOME_STATES_ACTION
                                    .action(dataResponse.state, null)),
                                of(WizardActions.CHANGE_HOME_CITY_ACTION
                                    .action(dataResponse.city, null)),
                                of(WizardActions.CHANGE_HOME_MUNICIPALITY_ACTION
                                    .action(dataResponse.municipality, null)),
                                of(WizardActions.CHANGE_HOME_COLONIES_ACTION
                                    .action(dataResponse.colony, calcColonyError)),
                                of(UIActions.IS_LOADED_ACTION
                                    .action(WizardActions.CHANGE_HOME_POSTAL_CODE_ACTION.name))
                            );
                        }),
                        catchError((error) => {
                            console.log('entraaa a error ON_CHANGE_POSTAL_CODE HOME-------------: ', error);
                            const errorIsNotFoundLocationError = Array.isArray(error) ?
                                error.includes(ErrorConstants.NOT_FOUND_LOCATION_ERROR) : false;

                            return processApiError([
                                errorIsNotFoundLocationError ?
                                    WizardMXActions.NOT_FOUND_LOCATION_ERROR_MX_ACTION.action() :
                                    UIActions.ERROR_GENERAL_ACTION.action(error, action, url, {}, 'GET'),
                                UIActions.IS_LOADED_ACTION.action(WizardActions.CHANGE_HOME_POSTAL_CODE_ACTION.name)
                            ])(error);
                        })
                    )
                );
            }
            return concat(
                of(WizardActions.CHANGE_HOME_STATES_ACTION
                    .action(defaultCatalog, ValidateConstant.ERROR_REQUIRED)),
                of(WizardActions.CHANGE_HOME_CITY_ACTION
                    .action(defaultCatalog, null)),
                of(WizardActions.CHANGE_HOME_MUNICIPALITY_ACTION
                    .action(defaultCatalog, ValidateConstant.ERROR_REQUIRED)),
                of(WizardActions.CHANGE_HOME_COLONIES_ACTION
                    .action([], ValidateConstant.ERROR_REQUIRED)),
                of(UIActions.IS_LOADED_ACTION
                    .action(WizardActions.CHANGE_HOME_POSTAL_CODE_ACTION.name))
            );
        })
    );

export const getLocationByPostalCodeEmployment = (action$, state$) =>
    action$.pipe(
        ofType(WizardActions.CHANGE_EMPLOYMENT_POSTAL_CODE_ACTION.name),
        debounceTime(300),
        mergeMap((action: AnyAction) => {

            const defaultCatalog = WizardValidationUtils.defaultCatalog;
            const COUNT_AUTO_SELECTED = 1;
            const url = `${MC.MCC_URL(action.country)}/catalogs/locations/${action.postalCode}`;
            return iif(() => (action.error === null),

                concat(
                    of(UIActions.IS_LOADING_ACTION
                        .action(WizardActions.CHANGE_EMPLOYMENT_POSTAL_CODE_ACTION.name)),
                    addCredentialAndExecute(headers => ajax.get(url, headers), state$.value).pipe(
                        timeout(MC.TIMEOUT),
                        mergeMap(({response, refreshTokenObs}: any) => {
                            const dataResponse = response.response.data;

                            const calcColonyError = dataResponse.colony.length > COUNT_AUTO_SELECTED ?
                                ValidateConstant.ERROR_REQUIRED : null;

                            return concat(
                                of(refreshTokenObs),
                                of(WizardActions.GOT_LOCATIONS_APPLICANT_EMPLOYMENT_MX_ACTION
                                    .action(dataResponse)),
                                of(WizardActions.CHANGE_EMPLOYMENT_STATES_ACTION
                                    .action(dataResponse.state, null)),
                                of(WizardActions.CHANGE_EMPLOYMENT_CITY_ACTION
                                    .action(dataResponse.city, null)),
                                of(WizardActions.CHANGE_EMPLOYMENT_MUNICIPALITY_ACTION
                                    .action(dataResponse.municipality, null)),
                                of(WizardActions.CHANGE_EMPLOYMENT_COLONIES_ACTION
                                    .action(dataResponse.colony, calcColonyError)),
                                of(UIActions.IS_LOADED_ACTION
                                    .action(WizardActions.CHANGE_EMPLOYMENT_POSTAL_CODE_ACTION.name))
                            );
                        }),
                        catchError((error) => {
                            console.log('entraaa a error ON_CHANGE_POSTAL_CODE EMPLOYMENT-------------: ', error);
                            const errorIsNotFoundLocationError = Array.isArray(error) ?
                                error.includes(ErrorConstants.NOT_FOUND_LOCATION_ERROR) : false;

                            return processApiError([
                                errorIsNotFoundLocationError ?
                                    WizardMXActions.NOT_FOUND_LOCATION_ERROR_MX_ACTION.action() :
                                    UIActions.ERROR_GENERAL_ACTION.action(error, action, url, {}, 'GET'),
                                UIActions.IS_LOADED_ACTION
                                    .action(WizardActions.CHANGE_EMPLOYMENT_POSTAL_CODE_ACTION.name)
                            ])(error);
                        })
                    )
                )
                ,
                concat(
                    of(WizardActions.CHANGE_EMPLOYMENT_STATES_ACTION
                        .action(defaultCatalog, ValidateConstant.ERROR_REQUIRED)),
                    of(WizardActions.CHANGE_EMPLOYMENT_CITY_ACTION
                        .action(defaultCatalog, null)),
                    of(WizardActions.CHANGE_EMPLOYMENT_MUNICIPALITY_ACTION
                        .action(defaultCatalog, ValidateConstant.ERROR_REQUIRED)),
                    of(WizardActions.CHANGE_EMPLOYMENT_COLONIES_ACTION
                        .action([], ValidateConstant.ERROR_REQUIRED)),
                )
            );
        })
    );

export const saveEmploymentPartialDataMXAction = (action$, state$) =>
    action$.pipe(
        ofType(WizardMXActions.SAVE_EMPLOYMENT_PARTIAL_DATA_MX_ACTION.name),
        mergeMap((action: AnyAction) => {
            const state = state$.value;
            const token = state.creditoReal.loanApplication.token;
            const url = `${MC.MCC_URL(COUNTRIES.MX.id)}/loan-applications-dealer/${token}`;
            const body = mapStateToStepApplicantEmploymentPartials(state);

            return concat(
                of(UIActions.IS_LOADING_ACTION
                    .action(WizardMXActions.SAVE_EMPLOYMENT_PARTIAL_DATA_MX_ACTION.name)),
                addCredentialAndExecute(headers => ajax.put(url, body, headers), state$.value).pipe(
                    timeout(MC.TIMEOUT),
                    mergeMap(({response, refreshTokenObs}: any) => {
                        console.log('------------------WizardMXActions.RETURNED_FROM_API------------- ', response);
                        return concat(
                            of(refreshTokenObs),
                            of(UIActions.IS_LOADED_ACTION
                                .action(WizardMXActions.SAVE_EMPLOYMENT_PARTIAL_DATA_MX_ACTION.name)),
                            of(WizardMXActions.SAVE_APPLICANT_DOMICILE_MX_ACTION.action())
                        );
                    }),
                    catchError((error) => {
                        console.log('---------- EROROROROROOROR ::: ', error);
                        return processApiError([
                            UIActions.IS_LOADED_ACTION.action(
                                WizardMXActions.SAVE_EMPLOYMENT_PARTIAL_DATA_MX_ACTION.name
                            ),
                            UIActions.ERROR_GENERAL_ACTION.action(
                                error, action, url, body, 'PUT'
                            )
                        ])(error);
                    })
                )
            );
        })
    );

export const saveApplicantDomicileMXAction = (action$, state$) =>
    action$.pipe(
        ofType(WizardMXActions.SAVE_APPLICANT_DOMICILE_MX_ACTION.name),
        mergeMap((action: AnyAction) => {
            const state = state$.value;
            const token = state.creditoReal.loanApplication.token;
            const url = `${MC.MCC_URL(COUNTRIES.MX.id)}/loan-applications-dealer/${token}`;
            const body = mapStateToStepApplicantDomicile(state);

            return concat(
                of(UIActions.IS_LOADING_ACTION
                    .action(WizardMXActions.SAVE_APPLICANT_DOMICILE_MX_ACTION.name)),
                addCredentialAndExecute(headers => ajax.put(url, body, headers), state$.value).pipe(
                    timeout(MC.TIMEOUT),
                    mergeMap(({response, refreshTokenObs}: any) => {
                        console.log('------------------WizardMXActions.RETURNED_FROM_API------------- ', response);
                        return concat(
                            of(refreshTokenObs),
                            of(LoanApplicationActions.SET_HIGHEST_STEP_ACTION
                                .action(body.extraData.step)),
                            iif(
                                () => state.creditoReal.ui.bureauAskForNipView.bureauAlreadyFailed,
                                of(WizardMXActions.GO_TO_CREDIT_HISTORY_MX_ACTION.action()),
                                concat(
                                    of(WizardMXActions.CLEAN_NIP_MX_ACTION.action()),
                                    of(WizardMXActions.GO_TO_PRIVACY_BUREAU_TERMS_MX_ACTION.action()),
                                )
                            ),
                            of(UIActions.IS_LOADED_ACTION
                                .action(WizardMXActions.SAVE_APPLICANT_DOMICILE_MX_ACTION.name))
                        );
                    }),
                    catchError((error) => {
                        console.log('---------- EROROROROROOROR ::: ', error);
                        return processApiError([
                            UIActions.IS_LOADED_ACTION.action(WizardMXActions.SAVE_APPLICANT_DOMICILE_MX_ACTION.name),
                            UIActions.ERROR_GENERAL_ACTION.action(
                                error, action, url, body, 'PUT'
                            )
                        ])(error);
                    })
                )
            );
        })
    );

export const goToBureauValidationMXAction = (action$, state$) => {
    return action$.pipe(
        ofType(WizardMXActions.GO_TO_PRIVACY_BUREAU_TERMS_MX_ACTION.name),
        mergeMap(action => of(
            push(`${RoutesConstant.PRIVACY_BUREAU_VALIDATION_PATH}/${state$.value.creditoReal.loanApplication.token}`))
        ));
};

export const goToCreditHistoryMXAction = (action$, state$) => {
    return action$.pipe(
        ofType(WizardMXActions.GO_TO_CREDIT_HISTORY_MX_ACTION.name),
        mergeMap(action => of(
            push(`${RoutesConstant.CREDIT_HISTORY_PATH}/${state$.value.creditoReal.loanApplication.token}`))
        ));
};

export const saveEmploymentDataMXAction = (action$, state$) =>
    action$.pipe(
        ofType(WizardMXActions.SAVE_APPLICANT_EMPLOYMENT_MX_ACTION.name),
        mergeMap((action: AnyAction) => {
            const state = state$.value;
            const token = state.creditoReal.loanApplication.token;
            const url = `${MC.MCC_URL(COUNTRIES.MX.id)}/loan-applications-dealer/${token}`;
            const body = mapStateToStepApplicantEmployment(state);

            return concat(
                of(UIActions.IS_LOADING_ACTION
                    .action(WizardMXActions.SAVE_APPLICANT_EMPLOYMENT_MX_ACTION.name)),
                addCredentialAndExecute(headers => ajax.put(url, body, headers), state$.value).pipe(
                    timeout(MC.TIMEOUT),
                    mergeMap(({response, refreshTokenObs}: any) => {
                        console.log('------------------WizardMXActions.RETURNED_FROM_API-------------- ', response);
                        return concat(
                            of(refreshTokenObs),
                            of(LoanApplicationActions.SET_HIGHEST_STEP_ACTION.action(body.extraData.step)),
                            state.creditoReal.ui.summaryStepView.returnToSummary ?
                                of(WizardMXActions.GO_TO_LOAN_APPLICATION_SUMMARY_MX_ACTION.action())
                                :
                                of(WizardMXActions.GO_TO_OTHER_REFERENCES_MX_ACTION.action()),
                            of(UIActions.IS_LOADED_ACTION
                                .action(WizardMXActions.SAVE_APPLICANT_EMPLOYMENT_MX_ACTION.name)),
                        );
                    }),
                    catchError((error) => {
                        console.log('---------- EROROROROROOROR ::: ', error);
                        return processApiError([
                            UIActions.IS_LOADED_ACTION.action(WizardMXActions.SAVE_APPLICANT_EMPLOYMENT_MX_ACTION.name),
                            UIActions.ERROR_GENERAL_ACTION.action(error, action, url, body, 'PUT')
                        ])(error);
                    })
                )
            );
        })
    );

export const goToReferencesMXAction = (action$, state$) => {
    return action$.pipe(
        ofType(WizardMXActions.GO_TO_OTHER_REFERENCES_MX_ACTION.name),
        mergeMap(action => of(
            push(`${RoutesConstant.REFERENCES_PATH}/${state$.value.creditoReal.loanApplication.token}`))
        ));
};

export const saveInsuranceMXAction = (action$, state$) =>
    action$.pipe(
        ofType(WizardMXActions.SAVE_INSURANCES_MX_ACTION.name),
        mergeMap((action: AnyAction) => {
            const state = state$.value;
            const token = state.creditoReal.loanApplication.token;
            const url = `${MC.MCC_URL(COUNTRIES.MX.id)}/loan-applications-dealer/${token}`;
            const body = mapStateToStepInsurance(state);

            return concat(
                of(UIActions.IS_LOADING_ACTION.action(WizardMXActions.SAVE_INSURANCES_MX_ACTION.name)),
                addCredentialAndExecute(headers => ajax.put(url, body, headers), state$.value).pipe(
                    timeout(MC.TIMEOUT),
                    mergeMap(({response, refreshTokenObs}: any) => {
                        console.log('------------------WizardMXActions.RETURNED_FROM_API---------------- ', response);
                        return concat(
                            of(refreshTokenObs),
                            of(LoanApplicationActions.SET_HIGHEST_STEP_ACTION.action(body.extraData.step)),
                            state.creditoReal.ui.summaryStepView.returnToSummary ?
                                of(WizardMXActions.GO_TO_LOAN_APPLICATION_SUMMARY_MX_ACTION.action())
                                :
                                of(WizardMXActions.GO_TO_FILES_UPLOAD_MX_ACTION.action()),
                            of(UIActions.IS_LOADED_ACTION
                                .action(WizardMXActions.SAVE_INSURANCES_MX_ACTION.name))
                        );
                    }),
                    catchError((error) => {
                        console.log('---------- EROROROROROOROR ::: ', error);
                        return processApiError([
                            UIActions.IS_LOADED_ACTION.action(WizardMXActions.SAVE_INSURANCES_MX_ACTION.name),
                            UIActions.ERROR_GENERAL_ACTION.action(error, action, url, body, 'PUT')
                        ])(error);
                    })
                )
            );
        })
    );

export const saveTurboCashCalculatorData = (action$, state$) =>
    action$.pipe(
        ofType(WizardMXActions.SAVE_TURBO_CASH_CALCULATOR_DATA_MX_ACTION.name),
        mergeMap((action: AnyAction) => {
            const state = state$.value;
            const token = state.creditoReal.loanApplication.token;
            const url = `${MC.MCC_URL(COUNTRIES.MX.id)}/turbo-cash/${token}/quote`;
            const body = mapStateToStepTurboCash(state, action);
            return concat(
                of(UIActions.IS_LOADING_ACTION.action(WizardMXActions.SAVE_TURBO_CASH_CALCULATOR_DATA_MX_ACTION.name)),
                addCredentialAndExecute(headers => ajax.put(url, body, headers), state$.value).pipe(
                    timeout(MC.TIMEOUT),
                    mergeMap(({response, refreshTokenObs}: any) => {
                        console.log('------------------WizardMXActions.RETURNED_FROM_API-------------------- ',
                            response);
                        return concat(
                            of(refreshTokenObs),
                            of(UIActions.IS_LOADED_ACTION.action(
                                WizardMXActions.SAVE_TURBO_CASH_CALCULATOR_DATA_MX_ACTION.name)
                            ),
                            of(WizardMXActions.CLEAN_STATE_ONCE_FINISHED_LOAN.action()),
                            of(LoanApplicationActions.SET_HIGHEST_STEP_ACTION.action(8)),
                            iif(
                                () => action.quoteAccepted,
                                of(WizardMXActions.GO_TO_TURBO_CASH_ACTION.action()),
                                of(WizardMXActions.GO_TO_NOT_ACCEPT_QUOTE_MX_ACTION.action())
                            )
                        );
                    }),
                    catchError((error) => {
                        console.log('---------- EROROROROROOROR ::: ', error);
                        return processApiError([
                            UIActions.IS_LOADED_ACTION.action(
                                WizardMXActions.SAVE_TURBO_CASH_CALCULATOR_DATA_MX_ACTION.name
                            ),
                            UIActions.ERROR_GENERAL_ACTION.action(error, action, url, body, 'POST')
                        ])(error);
                    })
                )
            );
        })
    );

export const saveProfileSimulatorData = (action$, state$) =>
    action$.pipe(
        ofType(WizardMXActions.SAVE_SIMULATOR_PROFILE_DATA_MX_ACTION.name),
        mergeMap((action: AnyAction) => {
            const state = state$.value;
            const token = state.creditoReal.loanApplication.token;
            const urlBaseWithBank = MC.MCC_URL_WITH_BANK(COUNTRIES.MX.id, BankTarget.CREDITO_REAL);
            const url = `${urlBaseWithBank}/banks/${token}/credit-condition-acceptation`;
            const body = mapStateToProfileSimulator(state, action);
            return concat(
                of(UIActions.IS_LOADING_ACTION.action(WizardMXActions.SAVE_SIMULATOR_PROFILE_DATA_MX_ACTION.name)),
                addCredentialAndExecute(headers => ajax.post(url, body, headers), state$.value).pipe(
                    timeout(MC.TIMEOUT),
                    mergeMap(({response, refreshTokenObs}: any) => {
                        console.log('------------------WizardMXActions.RETURNED_FROM_API-------------------- ',
                            response);
                        return concat(
                            of(refreshTokenObs),
                            of(UIActions.IS_LOADED_ACTION.action(
                                WizardMXActions.SAVE_SIMULATOR_PROFILE_DATA_MX_ACTION.name)
                            ),
                            iif(
                                () => action.quoteAccepted,
                                of(WizardMXActions.GO_TO_APPLICANT_EMPLOYMENT_MX_ACTION.action()),
                                of(WizardMXActions.GO_TO_NOT_ACCEPT_QUOTE_MX_ACTION.action())
                            )
                        );
                    }),
                    catchError((error) => {
                        console.log('---------- EROROROROROOROR ::: ', error);
                        return processApiError([
                            UIActions.IS_LOADED_ACTION.action(
                                WizardMXActions.SAVE_SIMULATOR_PROFILE_DATA_MX_ACTION.name
                            ),
                            UIActions.ERROR_GENERAL_ACTION.action(error, action, url, body, 'POST')
                        ])(error);
                    })
                )
            );
        })
    );

export const goToDomicileMXAction = (action$, state$) => {
    return action$.pipe(
        ofType(WizardMXActions.GO_TO_APPLICANT_DOMICILE_MX_ACTION.name),
        mergeMap(action => of(
            push(`${RoutesConstant.HOME_PATH}/${state$.value.creditoReal.loanApplication.token}`))
        ));
};

export const resendNip = (action$, state$) =>
    action$.pipe(
        ofType(WizardMXActions.RESEND_NIP_MX_ACTION.name),
        mergeMap((action) => {
            const state = state$.value;
            const token = state.creditoReal.loanApplication.token;
            const url = `${MC.MCC_URL(COUNTRIES.MX.id)}/nip-loan-applications-dealer/${token}/resend-nip-code`;
            return addCredentialAndExecute(headers => ajax.post(url, {}, headers), state).pipe(
                timeout(MC.TIMEOUT),
                mergeMap(({response, refreshTokenObs}: any) => {
                    return concat(
                        of(refreshTokenObs));
                }),
                catchError((error) => {
                    return processApiError(processNIPErrors(error, action, url, {}, 'POST'))(error);
                }));
        })
    );

function processNIPErrors(error, action, url, body, type) {
    const errorIsMaxNumberRequestBureauCodeError = Array.isArray(error) ?
        (error.includes(ErrorConstants.MAX_NUMBER_REQUEST_BUREAU_CODE_ERROR) ||
            error.includes(ErrorConstants.ALREADY_SENT_NIP_CODE_MAX_ALLOWED_TIMES_ERROR)) : false;
    const errorIsCreditBureauGatewayError = Array.isArray(error) ?
        error.includes(ErrorConstants.CREDIT_BUREAU_GATEWAY_ERROR) : false;
    const errorIsNotEligibleByCreditBureauError = Array.isArray(error) ?
        error.includes(ErrorConstants.NOT_ELIGIBLE_BY_CREDIT_BUREAU_ERROR) : false;
    const errorIsInvalidNipCodeError = Array.isArray(error) ?
        error.includes(ErrorConstants.INVALID_NIP_CODE_ERROR) : false;
    const errorIsNipCodeExpiredError = Array.isArray(error) ?
        error.includes(ErrorConstants.NIP_CODE_EXPIRED_ERROR) : false;
    const errorIsUndefinedError = Array.isArray(error) ?
        error.includes(ErrorConstants.UNDEFINED_ERROR) : false;

    const processed = [];
    if (errorIsMaxNumberRequestBureauCodeError) {
        processed.push(WizardMXActions.SET_BUREAU_FAILED_ACTION.action(true));
        processed.push(WizardMXActions.GO_TO_CREDIT_HISTORY_MX_ACTION.action());
    } else if (errorIsNotEligibleByCreditBureauError) {
        processed.push(WizardMXActions.GO_TO_NOT_ELIGIBLE_CREDIT_BUREAU_MX_ACTION.action());
    } else if (errorIsCreditBureauGatewayError || errorIsUndefinedError) {
        processed.push(WizardMXActions.SET_BUREAU_FAILED_ACTION.action(true));
        processed.push(WizardMXActions.GO_TO_CREDIT_BUREAU_GATEWAY_ERROR_MX_ACTION.action());
    } else if (errorIsNipCodeExpiredError) {
        processed.push(WizardMXActions.SET_BUREAU_FAILED_ACTION.action(true));
        processed.push(WizardMXActions.GO_TO_CREDIT_BUREAU_GATEWAY_ERROR_MX_ACTION.action());
    } else if (errorIsInvalidNipCodeError) {
        processed.push(WizardMXActions.GOT_API_ERROR_ACTION.action(ErrorConstants.INVALID_NIP_CODE_ERROR));
    } else {
        processed.push(UIActions.ERROR_GENERAL_ACTION.action(error, action, url, body, type));
    }
    return processed;
}

export const validateIdentityNip = (action$, state$) =>
    action$.pipe(
        ofType(WizardMXActions.VALIDATE_NIP_MX_ACTION.name),
        mergeMap((action) => {
            const state = state$.value;
            const token = state.creditoReal.loanApplication.token;
            const server: string = `${MC.MCC_URL(COUNTRIES.MX.id)}/nip-loan-applications-dealer/${token}`;
            const urlPrivacy = `${server}/validate-terms-conditions-nip`;
            const bodyPrivacy = mapStateToStepValidateIdentityNIP(state);

            return concat(
                of(UIActions.IS_LOADING_ACTION.action(WizardMXActions.VALIDATE_NIP_MX_ACTION.name)),
                addCredentialAndExecute(headers => ajax.post(urlPrivacy, bodyPrivacy, headers), state$.value).pipe(
                    timeout(MC.TIMEOUT),
                    mergeMap((response: any) => {
                        return concat(
                            of(UIActions.IS_LOADED_ACTION.action(WizardMXActions.VALIDATE_NIP_MX_ACTION.name)),
                            of(WizardMXActions.VALIDATE_BUREAU_NIP_MX_ACTION.action()),
                        );
                    }),
                    catchError((error) => {
                        const nipErrors = processNIPErrors(error, action, urlPrivacy, bodyPrivacy, 'POST');
                        nipErrors.push(UIActions.IS_LOADED_ACTION.action(WizardMXActions.VALIDATE_NIP_MX_ACTION.name));
                        return processApiError(nipErrors)(error);
                    }))
            );
        })
    );

export const validateProfile = (action$, state$) =>
    action$.pipe(
        ofType(WizardMXActions.VALIDATE_PROFILE_MX_ACTION.name),
        mergeMap((action) => {
            const state = state$.value;
            const token = state.creditoReal.loanApplication.token;
            const server = MC.MCC_URL_WITH_BANK(COUNTRIES.MX.id, BankTarget.CREDITO_REAL);
            const url: string = `${server}/banks/${token}/loan-application-profile`;

            return concat(
                of(UIActions.IS_LOADING_ACTION.action(WizardMXActions.VALIDATE_PROFILE_MX_ACTION.name)),
                addCredentialAndExecute(headers => ajax.get(url, headers), state$.value, true).pipe(
                    timeout(MC.TIMEOUT),
                    mergeMap(({response}: any) => {
                        const validateProfile = !!!MC.LOAN_APPLICANT_PROFILE.find(profile =>
                            profile.profile === response.response.data.profile);
                        return concat(
                            of(UIActions.IS_LOADED_ACTION.action(WizardMXActions.VALIDATE_PROFILE_MX_ACTION.name)),
                            iif(
                                () => validateProfile,
                                of(WizardMXActions.GO_TO_APPLICANT_EMPLOYMENT_MX_ACTION.action()),
                                concat(
                                    of(CalculatorActions.GOT_SIMULATOR_PROFILE_MX_ACTION.action(
                                        response.response.data.creditConditions
                                    )),
                                    of(WizardMXActions.GO_TO_SIMULATOR_PROFILE_ACTION.action())
                                )
                            )
                        );
                    }),
                    catchError(error => processApiError([
                        GlobalActions.ERROR_GENERAL_ACTION.action(error, action, url, {}, 'GET')
                    ])(error))
            ));
        })
    );

export const validateBureauNip = (action$, state$) =>
    action$.pipe(
        ofType(WizardMXActions.VALIDATE_BUREAU_NIP_MX_ACTION.name),
        mergeMap((action) => {
            const state = state$.value;
            const token = state.creditoReal.loanApplication.token;
            const server: string = `${MC.MCC_URL(COUNTRIES.MX.id)}/nip-loan-applications-dealer/${token}`;
            const urlBureau = `${server}/validate-buro-nip`;
            const bodyBureau = mapStateToStepValidateBureauNIP(state);

            return concat(
                of(UIActions.IS_LOADING_ACTION.action(WizardMXActions.VALIDATE_BUREAU_NIP_MX_ACTION.name)),
                addCredentialAndExecute(headers => ajax.post(urlBureau, bodyBureau, headers), state$.value).pipe(
                    timeout(MC.TIMEOUT),
                    mergeMap(({response, refreshTokenObs}: any) => {
                        console.log('------------------WizardMXActions.RETURNED_FROM_API------------- ', response);
                        return concat(
                            of(refreshTokenObs),
                            of(ModalActions.CLOSE_MODAL_ACTION.action()),
                            of(LoanApplicationActions.SET_HIGHEST_STEP_ACTION.action(bodyBureau.extraData.step)),
                            of(WizardMXActions.SET_CREDIT_BUREAU_ALREADY_VALIDATED_MX_ACTION.action()),
                            of(UIActions.IS_LOADED_ACTION
                                .action(WizardMXActions.VALIDATE_BUREAU_NIP_MX_ACTION.name)),
                            of(WizardMXActions.VALIDATE_PROFILE_MX_ACTION.action())
                        );
                    }),
                    catchError((error) => {
                        console.log('---------- EROROROROROOROR ::: ', error);
                        const nipErrors = processNIPErrors(error, action, urlBureau, bodyBureau, 'POST');
                        nipErrors.push(UIActions.IS_LOADED_ACTION
                            .action(WizardMXActions.VALIDATE_BUREAU_NIP_MX_ACTION.name));
                        return processApiError(nipErrors)(error);
                    }))
            );
        })
    );

export const goToBureauQueryErrorMXAction = (action$) => {
    return action$.pipe(
        ofType(WizardMXActions.GO_TO_CREDIT_BUREAU_GATEWAY_ERROR_MX_ACTION.name),
        mergeMap((action) => {
            const content = {
                type: MODAL_TYPE.SHOW_BUREAU_QUERY_ERROR_VIEW
            };
            const options = {
                closeOnOverlayClick: false
            };
            return of(ModalActions.OPEN_MODAL_DATA_ACTION.action(null, content, null, options));
        }));
};

export const checkIfAppliesToTurboCash = (action$, state$) => {
    return action$.pipe(
        ofType(WizardMXActions.GO_TO_NOT_ELIGIBLE_CREDIT_BUREAU_MX_ACTION.name),
        mergeMap((action: AnyAction) => {
            const state: State = state$.value;
            const minDownPayment: number = state.globalValidations.turboCash.minDownPayment;
            const maxDownPayment: number = state.globalValidations.turboCash.maxDownPayment;
            const token = state.creditoReal.loanApplication.token || action.token;
            const url = `${MC.MCC_URL(COUNTRIES.MX.id)}/loan-applications-dealer/${token}/turbo-cash-eligible`;
            return concat(
                of(UIActions.IS_LOADING_ACTION.action(WizardMXActions.GO_TO_NOT_ELIGIBLE_CREDIT_BUREAU_MX_ACTION.name)),
                addCredentialAndExecute(headers => ajax.get(url, headers), state$.value).pipe(
                    timeout(MC.TIMEOUT),
                    mergeMap(({response, refreshTokenObs}: any) => {
                        const appliesToTurboCash: boolean = response.response.data;
                        return concat(
                            of(refreshTokenObs),
                            of(UIActions.IS_LOADED_ACTION
                                .action(WizardMXActions.GO_TO_NOT_ELIGIBLE_CREDIT_BUREAU_MX_ACTION.name)),
                            iif(() => appliesToTurboCash,
                                of(WizardMXActions.APPLIES_TO_TURBO_CASH_MX_ACTION
                                    .action(minDownPayment, maxDownPayment)),
                                iif(() => !action.comesFromSummary,
                                    of(WizardMXActions.GO_TO_NOT_ACCEPT_QUOTE_MX_ACTION.action()),
                                    EMPTY
                                )
                            )
                        );
                    }),
                    catchError((error) => {
                        return processApiError([
                            UIActions.IS_LOADED_ACTION.action(WizardMXActions
                                .GO_TO_NOT_ELIGIBLE_CREDIT_BUREAU_MX_ACTION.name),
                            UIActions.ERROR_GENERAL_ACTION.action(error, action, url, {}, 'GET')
                        ])(error);
                    })
                )
            );
        }));
};

export const goToTurboCashSimulatorMXAction = (action$) => {
    return action$.pipe(
        ofType(WizardMXActions.APPLIES_TO_TURBO_CASH_MX_ACTION.name),
        mergeMap((action) => {
            return concat(
                of(ModalActions.CLOSE_MODAL_ACTION.action()),
                of(push(`${RoutesConstant.TURBO_CASH_CALCULATOR}`))
            );
        }));
};

export const goToNotAcceptQuoteTurboCashMXAction = (action$) => {
    return action$.pipe(
        ofType(WizardMXActions.GO_TO_NOT_ACCEPT_QUOTE_MX_ACTION.name),
        mergeMap((action) => {
            return concat(
                of(ModalActions.CLOSE_MODAL_ACTION.action()),
                of(push(`${RoutesConstant.BUREAU_NOT_ELIGIBLE}`))
            );
        }));
};

export const goToAcceptQuoteTurboCashMXAction = (action$) => {
    return action$.pipe(
        ofType(WizardMXActions.GO_TO_ACCEPT_QUOTE_MX_ACTION.name),
        mergeMap((action) => {
            return concat(
                of(ModalActions.CLOSE_MODAL_ACTION.action()),
                of(push(`${RoutesConstant.THANKS}`))
            );
        }));
};

export const saveOtherReferencesMXAction = (action$, state$) =>
    action$.pipe(
        ofType(WizardMXActions.SAVE_OTHER_REFERENCES_MX_ACTION.name),
        mergeMap((action: AnyAction) => {
            const state = state$.value;
            const token = state.creditoReal.loanApplication.token;
            const url = `${MC.MCC_URL(COUNTRIES.MX.id)}/loan-applications-dealer/${token}`;
            const body = mapStateToStepOtherReferences(state);

            return concat(
                of(UIActions.IS_LOADING_ACTION.action(WizardMXActions.SAVE_OTHER_REFERENCES_MX_ACTION.name)),
                addCredentialAndExecute(headers => ajax.put(url, body, headers), state$.value).pipe(
                    timeout(MC.TIMEOUT),
                    mergeMap(({response, refreshTokenObs}: any) => {
                        console.log('------------------WizardMXActions.RETURNED_FROM_API---------------- ', response);
                        return concat(
                            of(refreshTokenObs),
                            of(LoanApplicationActions.SET_HIGHEST_STEP_ACTION.action(body.extraData.step)),
                            state.creditoReal.ui.summaryStepView.returnToSummary ?
                                of(WizardMXActions.GO_TO_LOAN_APPLICATION_SUMMARY_MX_ACTION.action())
                                :
                                of(WizardMXActions.GO_TO_INSURANCES_MX_ACTION.action()),
                            of(UIActions.IS_LOADED_ACTION
                                .action(WizardMXActions.SAVE_OTHER_REFERENCES_MX_ACTION.name)),
                        );
                    }),
                    catchError((error) => {
                        console.log('---------- EROROROROROOROR ::: ', error);
                        return processApiError([
                            UIActions.IS_LOADED_ACTION.action(WizardMXActions.SAVE_OTHER_REFERENCES_MX_ACTION.name),
                            UIActions.ERROR_GENERAL_ACTION.action(error, action, url, body, 'PUT')
                        ])(error);
                    })
                )
            );
        })
    );

export const goToInsurancesMXAction = (action$, state$) => {
    return action$.pipe(
        ofType(WizardMXActions.GO_TO_INSURANCES_MX_ACTION.name),
        mergeMap(action => of(
            push(`${RoutesConstant.INSURANCES_PATH}/${state$.value.creditoReal.loanApplication.token}`))
        ));
};

export const saveCreditHistoryMXAction = (action$, state$) =>
    action$.pipe(
        ofType(WizardMXActions.SAVE_CREDIT_HISTORY_MX_ACTION.name),
        mergeMap((action: AnyAction) => {
            const state = state$.value;
            const token = state.creditoReal.loanApplication.token;
            const url = `${MC.MCC_URL(COUNTRIES.MX.id)}/loan-applications-dealer/${token}`;
            const body = mapStateToStepCreditHistory(state);

            return concat(
                of(UIActions.IS_LOADING_ACTION.action(WizardMXActions.SAVE_OTHER_REFERENCES_MX_ACTION.name)),
                addCredentialAndExecute(headers => ajax.put(url, body, headers), state$.value).pipe(
                    timeout(MC.TIMEOUT),
                    mergeMap(({response, refreshTokenObs}: any) => {
                        console.log('------------------WizardMXActions.RETURNED_FROM_API---------------- ', response);
                        return concat(
                            of(refreshTokenObs),
                            of(LoanApplicationActions.SET_HIGHEST_STEP_ACTION.action(body.extraData.step)),
                            of(WizardMXActions.SET_CREDIT_BUREAU_ALREADY_VALIDATED_MX_ACTION.action()),
                            of(WizardMXActions.GO_TO_APPLICANT_EMPLOYMENT_MX_ACTION.action()),
                            of(UIActions.IS_LOADED_ACTION
                                .action(WizardMXActions.SAVE_OTHER_REFERENCES_MX_ACTION.name)),
                        );
                    }),
                    catchError((error) => {
                        console.log('---------- EROROROROROOROR ::: ', error);
                        return processApiError([
                            UIActions.IS_LOADED_ACTION.action(WizardMXActions.SAVE_OTHER_REFERENCES_MX_ACTION.name),
                            UIActions.ERROR_GENERAL_ACTION.action(error, action, url, body, 'PUT')
                        ])(error);
                    })
                )
            );
        })
    );

export const goToEmploymentMXAction = (action$, state$) => {
    return action$.pipe(
        ofType(WizardMXActions.GO_TO_APPLICANT_EMPLOYMENT_MX_ACTION.name),
        mergeMap(action => of(
            push(`${RoutesConstant.WORK_PATH}/${state$.value.creditoReal.loanApplication.token}`))));
};

export const setEmploymentStateColonyAction = (action$, state$) => {
    return action$.pipe(
        ofType(WizardActions.SET_EMPLOYMENT_STATE_ACTION.name),
        delay(500), // TODO buscar mejor solucion
        mergeMap((action: AnyAction) => {
            return concat(
                of(WizardActions.CHANGE_EMPLOYMENT_COLONY_MX_ACTION
                    .action(action.employmentData.colony)),
            );
        })
    );
};

export const setEmploymentStateAction = (action$, state$) => {
    return action$.pipe(
        ofType(WizardActions.SET_EMPLOYMENT_STATE_ACTION.name),
        mergeMap((action: AnyAction) => {
            const country = state$.value.countrySelector.countrySelected;
            const monthlyIncomesValue = action.employmentData.monthlyIncomes.value === 0 ? '' :
                action.employmentData.monthlyIncomes.value;
            const monthlyIncomesError = monthlyIncomesValue === '' ? ValidateConstant.ERROR_REQUIRED : null;
            return concat(
                of(WizardActions.CHANGE_EMPLOYMENT_WORKPLACE_NAME_ACTION
                    .action(action.employmentData.workplaceName)),
                of(WizardActions.CHANGE_EMPLOYMENT_POSITION_ACTION
                    .action(action.employmentData.position)),
                of(WizardActions.CHANGE_EMPLOYMENT_WORKING_SINCE_ACTION
                    .action(action.employmentData.workingSince)),
                of(WizardActions.CHANGE_EMPLOYMENT_ADDRESS_ACTION
                    .action(action.employmentData.address)),
                of(WizardActions.CHANGE_EMPLOYMENT_EXT_NUMBER_ACTION
                    .action(action.employmentData.extNumber)),
                of(WizardActions.CHANGE_EMPLOYMENT_INT_NUMBER_ACTION
                    .action(action.employmentData.intNumber)),
                of(WizardActions.CHANGE_EMPLOYMENT_POSTAL_CODE_ACTION
                    .action(action.employmentData.postalCode, country, null)),
                of(WizardActions.CHANGE_EMPLOYMENT_WORKPLACE_PHONE_ACTION
                    .action(action.employmentData.workplacePhone)),
                of(WizardActions.CHANGE_EMPLOYMENT_WORKPLACE_PHONE_EXT_ACTION
                    .action(action.employmentData.workplacePhoneExt)),
                of(WizardActions.CHANGE_EMPLOYMENT_MONTHLY_INCOMES_ACTION
                    .action(monthlyIncomesValue, monthlyIncomesError)),
                of(WizardActions.CHANGE_INCLUDE_MONTHLY_INCOMES
                    .action(!!action.employmentData.monthlyIncomes.value, action.employmentData.monthlyIncomes.value))
            );
        })
    );
};

export const getLoanApplicationForSummaryMX = (action$, state$) =>
    action$.pipe(
        ofType(WizardMXActions.GET_LOAN_APPLICATION_SUMMARY_MX_ACTION.name),
        filter(action => state$.value.profile.accessToken !== ''),
        mergeMap((action: AnyAction) => {
            const state = state$.value;
            const urlBaseWithBank = MC.MCC_URL_WITH_BANK(COUNTRIES.MX.id, BankTarget.CREDITO_REAL);
            const url = `${urlBaseWithBank}/loan-applications-dealer/${action.token}/applicant-summary`;
            return concat(
                of(UIActions.IS_LOADING_ACTION
                    .action(WizardMXActions.GET_LOAN_APPLICATION_SUMMARY_MX_ACTION.name)),
                addCredentialAndExecute(headers => ajax.get(url, headers), state$.value).pipe(
                    timeout(MC.TIMEOUT),
                    mergeMap(({response, refreshTokenObs}: any) => {
                        {
                            const dataResponse: LoanApplicationApplicantSummaryDTO =
                                mapCRLoanApplicationToDTO(response.response.data);
                            const step = response.response.data.step;
                            const token = response.response.data.token;

                            const personalFieldSummary = WizardResponseValidationUtils
                                .getPersonalDataFieldSummary(dataResponse);
                            const calculatorFieldSummary = WizardResponseValidationUtils
                                .getCalculatorDataFieldSummary(dataResponse);
                            const desiredVehicleFieldSummary = WizardResponseValidationUtils
                                .getDesiredVehicleDataFieldSummary(dataResponse);
                            const homeFieldSummary = WizardResponseValidationUtils
                                .getHomeDataFieldSummary(dataResponse);
                            const employmentFieldSummary = WizardResponseValidationUtils
                                .getEmploymentDataFieldSummary(dataResponse);
                            return concat(
                                of(refreshTokenObs),
                                of(WizardMXActions.GOT_LOAN_APPLICATION_BY_TOKEN
                                    .action(dataResponse)),
                                of(WizardMXActions.GOT_LOAN_APPLICATION_SUMMARY_MX_ACTION
                                    .action(dataResponse)),
                                of(WizardMXActions.SET_CREDIT_BUREAU_VALIDATION_MX_ACTION
                                    .action(dataResponse.bureauNipValidated)),
                                of(UIActions.IS_LOADED_ACTION
                                    .action(WizardMXActions.GET_LOAN_APPLICATION_SUMMARY_MX_ACTION.name)),
                                iif(
                                    () => !dataResponse.finished && step === 4,
                                    iif(
                                        () => dataResponse.hasBureauError,
                                        iif(
                                            () => !dataResponse.bureauOptionSaved,
                                            of(WizardMXActions.GO_TO_CREDIT_HISTORY_MX_ACTION.action()),
                                            of(WizardMXActions.GO_TO_APPLICANT_EMPLOYMENT_MX_ACTION.action())
                                        ),
                                        iif(
                                            () => !!!dataResponse.acceptQuote,
                                            iif(
                                                () => !dataResponse.bureauEligible,
                                                of(WizardMXActions.GO_TO_NOT_ELIGIBLE_CREDIT_BUREAU_MX_ACTION
                                                    .action(token, true)),
                                                of(WizardMXActions.VALIDATE_PROFILE_MX_ACTION.action())
                                            ),
                                            iif(
                                                () => dataResponse.acceptQuote === GLOBAL.NON_ACCEPTED_QUOTE,
                                                of(WizardMXActions.GO_TO_NOT_ACCEPT_QUOTE_MX_ACTION.action()),
                                                of(WizardMXActions.GO_TO_APPLICANT_EMPLOYMENT_MX_ACTION.action())
                                            )
                                        )
                                    ),
                                    EMPTY
                                ),
                                iif(
                                    () => dataResponse.finished,
                                    of(WizardMXActions.GO_TO_LOAN_APPLICATION_SUMMARY_MX_ACTION.action()),
                                    EMPTY
                                ),
                                iif(
                                    () => (dataResponse.finished &&
                                        !dataResponse.marketingSource),
                                    of(ModalActions.OPEN_MODAL_DATA_ACTION.action(null,
                                        {type: MODAL_TYPE.SHOW_MARKETING_STEP_VIEW}, null,
                                        {closeOnOverlayClick: false})),
                                    EMPTY
                                ),
                                of(WizardMXActions.SET_PERSONAL_DATA_STATE_ACTION
                                    .action(personalFieldSummary)),
                                of(WizardMXActions.SET_CALCULATOR_DATA_STATE_ACTION
                                    .action(calculatorFieldSummary)),
                                of(WizardMXActions.SET_DESIRED_VEHICLE_DATA_STATE_ACTION
                                    .action(desiredVehicleFieldSummary)),
                                of(WizardMXActions.SET_HOME_DATA_STATE_ACTION
                                    .action(homeFieldSummary)),
                                of(WizardMXActions.SET_EMPLOYMENT_DATA_STATE_ACTION
                                    .action(employmentFieldSummary))
                            );
                        }
                    }),
                    catchError((error) => {
                        console.log('entraaa a error GOT_LOAN_APPLICATION_SUMMARY-------------: ', error);
                        const errorIsLoanApplicationUnauthorizedAccess = Array.isArray(error) ?
                            error.includes(ErrorConstants.LOAN_APPLICATION_UNAUTHORIZED_ACCESS_ERROR) : false;
                        const errorIsUserClaim = Array.isArray(error) ?
                            error.includes(ErrorConstants.USER_CLAIM_ERROR) : false;
                        const errorIsAuthTokenNotProvided = Array.isArray(error) ?
                            error.includes(ErrorConstants.AUTH_TOKEN_NOT_PROVIDED_ERROR) : false;
                        const errorIsTokenVerificationError = Array.isArray(error) ?
                            error.includes(ErrorConstants.TOKEN_VERIFICATION_ERROR) : false;
                        const errorIsSecurityProviderErrorNotMappedError = Array.isArray(error) ?
                            error.includes(ErrorConstants.SSO_SECURITY_PROVIDER_ERROR_NOT_MAPPED_ERROR) : false;
                        const errorIsUndefinedAuthorizationError = Array.isArray(error) ?
                            error.includes(ErrorConstants.UNDEFINED_AUTHORIZATION_ERROR) : false;
                        const shouldRedirectToCalculator = errorIsLoanApplicationUnauthorizedAccess
                            || errorIsUserClaim || errorIsAuthTokenNotProvided || errorIsTokenVerificationError
                            || errorIsSecurityProviderErrorNotMappedError || errorIsUndefinedAuthorizationError;
                        const errorsResponse = [];
                        errorsResponse.push(
                            UIActions.IS_LOADED_ACTION.action(
                                WizardMXActions.GET_LOAN_APPLICATION_SUMMARY_MX_ACTION.name)
                        );
                        if (shouldRedirectToCalculator) {
                            errorsResponse.push(LoginActions.LOGOUT_ACTION.action());
                        } else {
                            errorsResponse.push(UIActions.ERROR_GENERAL_ACTION.action(error, action, url, {}, 'GET'));
                        }
                        return processApiError(errorsResponse)(error);
                    })
                )
            );
        })
    );

export const getLoanApplicationDocuments = (action$, state$) =>
    action$.pipe(
        ofType(WizardMXActions.GOT_LOAN_APPLICATION_SUMMARY_MX_ACTION.name),
        debounceTime(300),
        filter(_ => state$.value.profile.accessToken !== ''),
        filter(_ => state$.value.creditoReal.loanApplication.token !== ''),
        //filter(_ => state$.value.router?.location?.pathname?.includes(RoutesConstant.HOME_PATH)),
        mergeMap((action: AnyAction) => {
            const urlBaseWithBank = MC.MCC_URL(COUNTRIES.MX.id);
            const url = `${urlBaseWithBank}/loan-applications-documents/${state$.value.creditoReal.loanApplication.token}/documents`;
            return concat(
                of(UIActions.IS_LOADING_ACTION.action(WizardMXActions.GET_LOAN_APPLICATION_SUMMARY_MX_ACTION.name)),
                addCredentialAndExecute(headers => ajax.get(url, headers), state$.value).pipe(
                    timeout(MC.TIMEOUT),
                    mergeMap(({response, refreshTokenObs}: any) =>
                        concat(
                            of(refreshTokenObs),
                            of(WizardActions.UPLOADED_FILES_ACTION.action(response.response.data)),
                        )
                    ),
                    catchError((error) =>
                        processApiError([
                            UIActions.ERROR_GENERAL_ACTION.action(error, action, url, {}, 'GET')
                        ])(error)
                    ),
                ),
                of(UIActions.IS_LOADED_ACTION.action(WizardMXActions.GET_LOAN_APPLICATION_SUMMARY_MX_ACTION.name)),
            );
        })
    );

export const fillCalculatorDataMX = (action$, state$) =>
    action$.pipe(
        ofType(WizardMXActions.FILL_CALCULATOR_DATA_MX_ACTION.name),
        delay(500),
        filter(action => state$.value.profile.accessToken !== ''),
        mergeMap((action) => {
            const state: State = state$.value;
            const catalogs = state.catalogs;
            const calculator = state.creditoReal.calculator;
            const year = calculator.yearSelected;
            const brand = calculator.brandSelected;
            const model = calculator.modelSelected;
            const version = calculator.versionSelected;
            const province = calculator.provinceSelected;
            return concat(
                of(CalculatorActions.YEAR_SELECTED_ACTION.action(year, null)),
                of(CalculatorActions.BRAND_SELECTED_ACTION.action(brand, null)),
                of(CalculatorActions.MODEL_SELECTED_ACTION.action(model, null)),
                of(CalculatorActions.VERSION_SELECTED_ACTION.action(version, null)),
                of(CalculatorActions.CALCULATE_QUOTAS_MX_ACTION.action(
                    province.payload,
                    version.payload,
                    year.id,
                    calculator.hasInsurance,
                    calculator.price,
                    calculator.downPayment)
                ),
                of(CalculatorActions.MONTHLY_PAYMENT_SELECTED_ACTION
                    .action(calculator.monthlyPayment, null))
            );
        })
    );

export const goToSummaryMXAction = (action$, state$) => {
    return action$.pipe(
        ofType(WizardMXActions.GO_TO_LOAN_APPLICATION_SUMMARY_MX_ACTION.name),
        mergeMap(action => of(
            push(`${RoutesConstant.SUMMARY_PATH}/${state$.value.creditoReal.loanApplication.token}`))
        ));
};

export const goToFilesUploadMXAction = (action$, state$) => {
    return action$.pipe(
        ofType(WizardMXActions.GO_TO_FILES_UPLOAD_MX_ACTION.name),
        mergeMap(action => of(
            push(`${RoutesConstant.FILES_UPLOAD_PATH}/${state$.value.creditoReal.loanApplication.token}`))
        ));
};

async function processFiles(files, fileType, fileSection) {
    const processedFilesPromises = [];
    files.forEach((item) => {
        processedFilesPromises.push(processFile(item, fileType, fileSection));
    });
    return Promise.all(processedFilesPromises);

}

function processFile(file, fileType, fileSection) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
            const fileAsBinaryString = reader.result;
            const base64 = fileAsBinaryString ? (fileAsBinaryString as string).split(',')[1] : null;
            const processed = {
                base64,
                mimeType: file.type,
                fileName: file.name,
                docType: fileType,
                section: fileSection
            };
            return base64 ? resolve(processed) : reject(null);
        };

        reader.readAsDataURL(file);
    });
}

export const goToStep = (action$) => {
    return action$.pipe(
        ofType(WizardMXActions.SET_RETURN_TO_SUMMARY.name),
        mergeMap((action: AnyAction) => {
            switch (action.stepId) {
                case 1:
                    return of(WizardMXActions.GO_TO_CALCULATOR_MX_ACTION.action());
                case 2:
                    return of(WizardMXActions.GO_TO_APPLICANT_DATA_MX_ACTION.action());
                case 3:
                    return of(WizardMXActions.GO_TO_APPLICANT_DOMICILE_MX_ACTION.action());
                case 4:
                    return of(WizardMXActions.GO_TO_APPLICANT_EMPLOYMENT_MX_ACTION.action());
                case 5:
                    return of(WizardMXActions.GO_TO_OTHER_REFERENCES_MX_ACTION.action());
                case 6:
                    return of(WizardMXActions.GO_TO_INSURANCES_MX_ACTION.action());
                default:
                    break;
            }
        }));
};

export const goToFinishedMXAction = (action$, state$) => {
    return action$.pipe(
        ofType(WizardMXActions.GO_TO_SENT_LOAN_APPLICATION_MX_ACTION.name),
        mergeMap(action => of(push(`${RoutesConstant.FINISHED}`))));
};

export const saveMarketingMXAction = (action$, state$) =>
    action$.pipe(
        ofType(WizardMXActions.SAVE_MARKETING_MX_ACTION.name),
        mergeMap((action: AnyAction) => {
            const state = state$.value;
            const token = state.creditoReal.loanApplication.token;
            const url = `${MC.MCC_URL(COUNTRIES.MX.id)}/loan-applications-dealer/${token}`;
            const body = mapStateToStepMarketingSource(state);

            return concat(
                of(UIActions.IS_LOADING_ACTION.action(WizardMXActions.SAVE_MARKETING_MX_ACTION.name)),
                addCredentialAndExecute(headers => ajax.put(url, body, headers), state$.value).pipe(
                    timeout(MC.TIMEOUT),
                    mergeMap(({response, refreshTokenObs}: any) => {
                        return concat(
                            of(refreshTokenObs),
                            of(ModalActions.CLOSE_MODAL_ACTION.action()),
                            of(UIActions.IS_LOADED_ACTION
                                .action(WizardMXActions.SAVE_MARKETING_MX_ACTION.name))
                        );
                    }),
                    catchError((error) => {
                        return processApiError([
                            UIActions.IS_LOADED_ACTION.action(WizardMXActions.SAVE_MARKETING_MX_ACTION.name),
                            UIActions.ERROR_GENERAL_ACTION.action(error, action, url, body, 'PUT')
                        ])(error);
                    })
                )
            );
        })
    );

export const saveFileUploadMXAction = (action$, state$) =>
    action$.pipe(
        ofType(WizardMXActions.FINISH_LOAN_APPLICATION_ACTION.name),
        mergeMap((action: AnyAction) => {
            const state = state$.value;
            const token = state.creditoReal.loanApplication.token;
            const url = `${MC.MCC_URL(COUNTRIES.MX.id)}/loan-applications-dealer/${token}/finish-online`;
            const body = {};

            return concat(
                of(UIActions.IS_LOADING_ACTION
                    .action(WizardMXActions.FINISH_LOAN_APPLICATION_ACTION.name)),
                addCredentialAndExecute(headers => ajax.put(url, body, headers), state$.value).pipe(
                    timeout(MC.TIMEOUT),
                    mergeMap(({response, refreshTokenObs}: any) => {
                        return concat(
                            of(refreshTokenObs),
                            of(WizardMXActions.GO_TO_LOAN_APPLICATION_SUMMARY_MX_ACTION.action()),
                            of(UIActions.IS_LOADED_ACTION
                                .action(WizardMXActions.FINISH_LOAN_APPLICATION_ACTION.name))
                        );
                    }),
                    catchError((error) => {
                        const hasLoanApplicationAlreadyFinishedError = Array.isArray(error) ?
                            error.includes(ErrorConstants.LOAN_APPLICATION_ALREADY_FINISHED_ERROR) : false;
                        return processApiError([
                            UIActions.IS_LOADED_ACTION.action(WizardMXActions.FINISH_LOAN_APPLICATION_ACTION.name),
                            hasLoanApplicationAlreadyFinishedError ?
                                WizardMXActions.GO_TO_LOAN_APPLICATION_SUMMARY_MX_ACTION.action() :
                                UIActions.ERROR_GENERAL_ACTION.action(error, action, url, body, 'PUT')
                        ])(error);
                    })
                )
            );
        })
    );

export const goToLoanApplicationSummaryMXAction = (action$, state$) => {
    return action$.pipe(
        ofType(WizardMXActions.GO_TO_LOAN_APPLICATION_SUMMARY_MX_ACTION.name),
        mergeMap(action => of(
            push(`${RoutesConstant.SUMMARY_PATH}/${state$.value.creditoReal.loanApplication.token}`))
        ));
};
